import step1 from '../assets/images/step-1.png';
import step2 from '../assets/images/step-2.png';
import step3 from '../assets/images/step-3.png';
import step4 from '../assets/images/step-4.png';
import step5 from '../assets/images/step-5.png';

// O ícone é definido pelo NÚMERO do step (índice), não pela posição final.
// step-4 é o troféu; step-5 é o ícone de comissão.
const STEP_ICONS = [step1, step2, step3, step4, step5];

export const MIN_STEPS = 2;
export const MAX_STEPS = 5;

export function getStepIcons(stepCount: number): string[] {
  return Array.from({ length: stepCount }, (_, index) => {
    const isLast = index === stepCount - 1;

    // Comportamento legado: funis com menos de MAX_STEPS steps sempre exibem o
    // troféu no último step, independentemente do número dele. Isso preserva a
    // experiência de clientes com 2/3/4 steps (não pode ser alterado).
    if (isLast && stepCount < MAX_STEPS) {
      return step4;
    }

    return STEP_ICONS[index] ?? STEP_ICONS[STEP_ICONS.length - 1];
  });
}
